export default __webpack_public_path__ + "static/colosseum-d9f25b66ca84f6a7cbd890d8144be325.jpg";